import { Table } from "react-bootstrap";

/**
 * StyledTableHeader - Consistent header cell styling (px-5 = 20px horizontal padding)
 * Matches memts table column spacing
 */
export function StyledTableHeader({ children, className = "" }) {
  return (
    <th className={`styled-table-header ${className}`}>
      {children}
    </th>
  );
}

/**
 * StyledTableCell - Consistent data cell styling (px-5 = 20px horizontal padding)
 * Matches memts table column spacing
 */
export function StyledTableCell({ children, className = "", ...props }) {
  return (
    <td className={`styled-table-cell ${className}`} {...props}>
      {children}
    </td>
  );
}

/**
 * StyledTable - Wrapper for consistent table styling across the application
 * All child th/td elements should use StyledTableHeader and StyledTableCell
 * for consistent px-5 (20px) column spacing
 */
export function StyledTable({ 
  children, 
  className = "", 
  responsive = "sm",
  ...props 
}) {
  return (
    <Table 
      responsive={responsive} 
      className={`styled-table ${className}`}
      {...props}
    >
      {children}
    </Table>
  );
}

/**
 * StyledTableRow - Wrapper for consistent row styling
 */
export function StyledTableRow({ children, className = "", ...props }) {
  return (
    <tr className={`styled-table-row ${className}`} {...props}>
      {children}
    </tr>
  );
}
